﻿import { mapGetters, mapState } from 'vuex';
import errorMessage from './errorMessage.vue';
import Vue from 'vue'

export default {
    name: 'ca-orderitems',
    props: ['viewmodel', 'viewusecashflag', 'viewallowedinstallments', 'viewminupfrontpayment', 'viewminstallmentstepamount', 'viewmininstallmentamount', 'viewmininstallmentamount', 'viewmincreditpayment'],
    components: {
        'ca-error-message': errorMessage,
    },
    data: () => ({
        VATMultiplyer: 0.2,
        timerHandler: null,
        activeWatcher: false,
        paymentBy: 'cash',
        upfrontAmount: 0,
        creditAccountConfiguration: {
            upfrontAmountPerSubscription: {}
        },
        lastInstallment: 0
    }),
    mounted: function () {
        this.$store.watch(state => state.creditaccount.orderStored, (newState) => {
            const self = this;
            this.upfrontAmount = this.creditAgreement.upfrontAmount;
            // Initialize slider values, set the configuration dictionary (key=subscriptionItemId, value=upfrontPayment)
            for (let i = 0; i < this.creditAgreement.subscriptionAgreementItems.length; i++) {
                let subscriptionItemId = this.creditAgreement.subscriptionAgreementItems[i].id;
                Vue.set(this.creditAccountConfiguration.upfrontAmountPerSubscription, subscriptionItemId, this.creditAgreement.subscriptionAgreementItems[i].upfrontPayment.toString());
            }

            setTimeout(function () {
                self.activeWatcher = true;
            }, 500);
        });

        this.$store.watch(state => state.creditaccount.downPaymentPlan.stored, (newState) => {
            for (let i = 0; i < this.creditAgreement.subscriptionAgreementItems.length; i++) {
                let subscription = this.creditAgreement.subscriptionAgreementItems[i];

                let installmentsRadioButtons = document.getElementsByName('creditInstallmentButtons_' + subscription.id);
                for (let j = 0; j < installmentsRadioButtons.length; j++) {
                    if (installmentsRadioButtons[j].value === subscription.numberOfInstallments.toString()) {
                        installmentsRadioButtons[j].checked = true;
                    }
                }
            }
        });

        // Set texts
        this.$store.dispatch('setPageLoaderTexts', {
            'loaderUpdateHardwarePaymentLoaderTitle': this.viewmodel.updateHardwarePaymentLoaderTitle,
            'loaderUpdateHardwarePaymentLoaderMessage': this.viewmodel.updateHardwarePaymentLoaderMessage
        });
    },
    methods: {
        // Get data methods
        getSubscriptionAgreementItem: function (id) {
            return this.creditAgreement.subscriptionAgreementItems.find(function (x) { return x.id === id; });
        },
        getDownPaymentPlan: function (subscriptionAgreement) {
            for (let i = 0; i < this.downPaymentPlan.plans.length; i++) {
                const downPaymentPlanItem = this.downPaymentPlan.plans[i];

                for (let h = 0; h < subscriptionAgreement.hardwareItems.length; h++) {
                    let hardwareItem = subscriptionAgreement.hardwareItems[h];

                    if (hardwareItem.equipmentType.toUpperCase() === downPaymentPlanItem.hardwareType.toUpperCase() &&
                        hardwareItem.equipmentBrand.toUpperCase() === downPaymentPlanItem.hardwareBrand.toUpperCase()) {

                        return downPaymentPlanItem;
                    }
                }
            }

            return this.downPaymentPlan.plans[0];
        },
        getPaymentBy: function (id) {
            const filtered = this.getSubscriptionAgreementItem(id);
            return filtered ? filtered.paymentBy : 'cash';
        },
        getInstallmentAmount: function (months, id) {
            const subscriptionAgreementItem = this.getSubscriptionAgreementItem(id);

            const amount = this.getTotalPricePerSubscription(subscriptionAgreementItem) - this.getTotalDiscountPerSubscription(subscriptionAgreementItem) - Number(subscriptionAgreementItem.upfrontPayment);

            return this.getMonthlyInstallments(amount, months);
        },
        getLastInstallment: function (months, id) {
            const subscriptionAgreementItem = this.getSubscriptionAgreementItem(id);

            const amount = this.getTotalPricePerSubscription(subscriptionAgreementItem) - this.getTotalDiscountPerSubscription(subscriptionAgreementItem) - Number(subscriptionAgreementItem.upfrontPayment);

            return (amount - (months - 1) * this.getMonthlyInstallments(amount, months)).toFixed(2);
        },
        getInstallmentAmountByOrder: function (months, subscriptionAgreementItems) {
            const amount = this.getTotalPriceAgreementItemperOrder(subscriptionAgreementItems) - this.order.discount - Number(this.creditAgreement.upfrontAmount);

            return months ? this.getMonthlyInstallments(amount, months) : 0;
        },
        getLastInstallmentByOrder: function (months) {
            const amount = this.getTotalPriceAgreementItemperOrder(this.creditAgreement.subscriptionAgreementItems) - this.order.discount - Number(this.creditAgreement.upfrontAmount);

            return months ? (amount - (months - 1) * this.getMonthlyInstallments(amount, months)).toFixed(2) : 0;
        },
        getMonthlyInstallments: function (amount, months) {
            return (Math.ceil(100 * amount / months) / 100).toFixed(2);
        },
        getUpfrontPaymentForSubscription: function (id) {
            return this.creditAccountConfiguration.upfrontAmountPerSubscription[id];
        },
        getTotalPricePerSubscription: function (subscriptionAgreementItem) {
            let sum = 0;

            for (let i = 0; i < subscriptionAgreementItem.hardwareItems.length; i++) {
                let hwItem = subscriptionAgreementItem.hardwareItems[i];

                sum += hwItem.price;
            }

            return sum;
        },
        getTotalDiscountPerSubscription: function (subscriptionAgreementItem) {
            let sum = 0;

            for (let i = 0; i < subscriptionAgreementItem.hardwareItems.length; i++) {
                if (subscriptionAgreementItem.hardwareItems[i].discount === null) {
                    continue;
                }

                sum += subscriptionAgreementItem.hardwareItems[i].discount;
            }

            return sum;
        },
        getTotalPriceAgreementItemperOrder: function (subscriptionAgreementItems) {
            var totalOrderSum = 0;
            for (let j = 0; j < subscriptionAgreementItems.length; j++) {
                const Item = this.getSubscriptionAgreementItem(subscriptionAgreementItems[j].id);
                totalOrderSum += this.getTotalPricePerSubscription(Item);
            }
            return totalOrderSum;
        },
        getNewHWItemPrice: function (originalPrice, discount) {
            return originalPrice - discount;
        },
        getSliderMaxValue: function (subscriptionAgreementItem) {
            if (this.downPaymentPlan.stored) {
                const downPaymentPlan = this.getDownPaymentPlan(subscriptionAgreementItem);

                let numberOfInstallments = subscriptionAgreementItem.numberOfInstallments > 0 ?
                    subscriptionAgreementItem.numberOfInstallments :
                    downPaymentPlan.allowedInstalments[0];

                var totalPerSubscription = this.getTotalPricePerSubscription(subscriptionAgreementItem);
                var totalDiscountPerSubscription = this.getTotalDiscountPerSubscription(subscriptionAgreementItem);

                return totalPerSubscription - totalDiscountPerSubscription - (numberOfInstallments * downPaymentPlan.minInstallmentAmount);
            }
            else {
                return 0;
            }
        },
        getSliderMaxValueByOrder: function (subscriptionAgreementItems) {
            let numberOfInstallments = this.creditAgreement.numberOfInstallments > 0 ?
                this.creditAgreement.numberOfInstallments :
                this.viewallowedinstallments[0];
            const totalPerOrder = this.getTotalPriceAgreementItemperOrder(subscriptionAgreementItems);
            const totalDiscountPerOrder = this.order.discount;

            return totalPerOrder - totalDiscountPerOrder - (numberOfInstallments * this.viewmininstallmentamount);

        },

        // Set/reset methods
        setUpfrontPayment: function (id, newUpfrontPaymentAmount) {
            const data = {
                'id': id,
                'upfrontPayment': newUpfrontPaymentAmount
            };

            this.$store.dispatch('changeUpfrontPayment', data);

            const creditAgreementItem = this.getSubscriptionAgreementItem(id);

            if (creditAgreementItem.numberOfInstallments > 0) {
                this.setSelectedCreditInstallments(id, creditAgreementItem.numberOfInstallments);
            }
        },
        setSelectedCreditInstallments: function (id, installments) {
            const subscriptionAgreementItem = this.getSubscriptionAgreementItem(id);

            const downPaymentPlan = this.getDownPaymentPlan(subscriptionAgreementItem);
            const monthlyInstallment = this.getInstallmentAmount(installments, id);

            if (monthlyInstallment >= downPaymentPlan.minInstallmentAmount) {
                const lastInstallment = this.getLastInstallment(installments, id);
                const selectedCreditInstallmentData = {
                    'id': id,
                    'installments': installments,
                    'monthlyInstallment': monthlyInstallment,
                    'lastInstallment': lastInstallment
                };

                this.$store.dispatch('setSelectedCreditInstallments', selectedCreditInstallmentData);
            }
            else {
                this.resetInstallmentSelection(id, "no");
            }
        },
        setSelectedCreditInstallmentsByOrder: function (installments) {
            const monthlyInstallment = this.getInstallmentAmountByOrder(installments, this.creditAgreement.subscriptionAgreementItems);

            if (monthlyInstallment >= this.viewmininstallmentamount) {
                const lastInstallment = this.getLastInstallmentByOrder(installments);
                this.$store.dispatch('setSelectedCreditInstallmentsByOrder', {
                    'installments': installments,
                    'monthlyInstallment': monthlyInstallment,
                    'lastInstallment': lastInstallment
                });
            }
            else {
                this.resetInstallmentSelectionByOrder(this.creditAgreement.subscriptionAgreementItems, "no");
            }
        },
        resetUpfrontPayment: function (id, value) {
            const subscriptionAgreementItem = this.getSubscriptionAgreementItem(id);
            this.creditAccountConfiguration.upfrontAmountPerSubscription[subscriptionAgreementItem.id] = value.toString();

            this.$store.dispatch('changeUpfrontPayment', { 'id': id, 'upfrontPayment': value });

            if (subscriptionAgreementItem.numberOfInstallments > 0) {
                this.setSelectedCreditInstallments(id, subscriptionAgreementItem.numberOfInstallments);
            }
        },
        setUpfrontAmount: function (upfrontAmount) {
            const installmentAmount = this.getInstallmentAmountByOrder(this.creditAgreement.numberOfInstallments, this.creditAgreement.subscriptionAgreementItems);
            this.lastInstallment = this.getLastInstallmentByOrder(this.creditAgreement.numberOfInstallments);
            this.$store.dispatch('updateUpfrontPaymentByOrder', { upfrontAmount, installmentAmount, lastInstallment: this.lastInstallment, numberOfInstallments: this.creditAgreement.numberOfInstallments });
        },
        resetUpfrontPaymentByOrder: function () {
            this.setUpfrontAmount(this.creditAgreement.upfrontAmount);
            if (this.creditAgreement.numberOfInstallments > 0) {
                this.setSelectedCreditInstallmentsByOrder(this.creditAgreement.numberOfInstallments);
            }
        },
        resetInstallmentSelection: function (id, fullReset) {
            let installmentRadioButtons = document.getElementsByName('creditInstallmentButtons_' + id);

            for (let i = 0; i < installmentRadioButtons.length; i++) {
                installmentRadioButtons[i].checked = false;
            }

            const resetData = {
                'id': id,
                'fullReset': fullReset
            };

            this.$store.dispatch('resetCreditAgreementItem', resetData);
        },
        resetInstallmentSelectionByOrder: function (items, fullReset) {
            let installmentRadioButtons = document.getElementsByName('creditInstallmentButtons');
            for (let i = 0; i < installmentRadioButtons.length; i++) {
                installmentRadioButtons[i].checked = false;
            }
            this.upfrontAmount = 0;
            const resetData = {
                'id': items,
                'fullReset': fullReset
            };
            this.$store.dispatch('resetCreditAgreementItemByOrder', resetData);
        },

        // OnChange hanlders
        upfrontAmount_OnChange: function (id) {
            const self = this;
            self.setUpfrontPayment(id, self.creditAccountConfiguration.upfrontAmountPerSubscription[id]);

            const subscriptionAgreementItem = self.getSubscriptionAgreementItem(id);
            if (subscriptionAgreementItem.hardwarePaymentId > 0) {
                clearTimeout(self.timerHandler);
                self.timerHandler = setTimeout(function () {
                    self.$store.dispatch('updateHardwarePayment', subscriptionAgreementItem);
                }, 1000);
            }
        },
        upfrontAmountByOrder_OnChange: function (subscriptionItems) {
            const self = this;
            self.setUpfrontAmount(self.upfrontAmount);
            if (self.creditAgreement.numberOfInstallments > 0) {
                self.setSelectedCreditInstallmentsByOrder(self.creditAgreement.numberOfInstallments);
            }

            clearTimeout(self.timerHandler);
            self.timerHandler = setTimeout(function () {
                if (self.creditAgreement.numberOfInstallments !== 0) {
                    self.$store.dispatch('hardwarePaymentByOrder', subscriptionItems);
                }
            }, 1000);
        },
        // Show resolvers
        showConfigurationPanel: function (id) {
            const filtered = this.getSubscriptionAgreementItem(id);
            const returnVal = filtered.paymentBy === 'credit';

            return returnVal;
        },
        showItemDiscount: function (item) {
            let result = false;
            if (!this.discounts.showDiscounts) {
                result = false;
            }
            else if (this.discounts.showDiscounts && this.discounts.discountType == "PayNowOnly" && this.getPaymentBy(item.id) === 'cash') {
                result = true;
            }
            else if (this.discounts.showDiscounts && this.discounts.discountType == "CaIncluded") {
                result = true;
            }
            else {
                result = false;
            }
            return result;
        },

        // Update methods
        updateHardwareDiscounts: function (subscriptionAgreementItem, hardwareItem, e) {
            // If input value is empty, then set zero as the input value
            if (e.target.value === "") {
                e.target.value = "0";
                e.target.classList.remove('ts-form-item__error');
            }

            this.validateDiscountAmount(e, hardwareItem.price)

            let discountAmount = e.target.value === "" ? 0 : Number(e.target.value);
            let discountVat = this.VATMultiplyer * discountAmount;
            let hardwareItemKey = "" + hardwareItem.hardwareItemId;

            var discount = {
                'currency': 'DKK',
                'amount': discountAmount,
                'VAT': discountVat
            };

            let updateDiscountData = {
                'selectedCreditAgreementItem': subscriptionAgreementItem,
                'hardwareItem': hardwareItem,
                'hardwareItemId': [hardwareItemKey],
                'discount': discount
            };
            this.$store.dispatch('updateDiscountInHardwarePayment', updateDiscountData);

            if (this.getPaymentBy(subscriptionAgreementItem.id) === 'credit') {
                this.resetInstallmentSelection(subscriptionAgreementItem.id, "partial");
                this.resetUpfrontPayment(subscriptionAgreementItem.id, this.getDownPaymentPlan(subscriptionAgreementItem).minUpfrontPayment);
            }
            else {
                this.resetInstallmentSelection(subscriptionAgreementItem.id, "yes");
            }

            if (subscriptionAgreementItem.hardwarePaymentId === 0) {
                this.$store.dispatch('createHardwarePayment', subscriptionAgreementItem);
            }
            else {
                this.$store.dispatch('updateHardwarePayment', subscriptionAgreementItem);
            }
        },
        updateDiscountsByOrder: function (subscriptionAgreementItems, totalOrderPrice, e) {
            if (e.target.value === "") {
                e.target.value = "0";
                e.target.classList.remove('ts-form-item__error');
            }
            
            this.validateDiscountAmount(e, totalOrderPrice)
            let discountAmount = e.target.value === "" ? 0 : Number(e.target.value);
            let discountVat = this.VATMultiplyer * discountAmount;
            var discount = {
                'currency': 'DKK',
                'amount': discountAmount,
                'VAT': discountVat
            };

            let updateDiscountData = {
                'discount': discount
            };

            this.$store.dispatch('updateDiscountByOrder', updateDiscountData);
            if (this.order && this.order.paymentBy.toLowerCase() === 'credit') {
                this.resetInstallmentSelectionByOrder(subscriptionAgreementItems, "partial");
                this.resetUpfrontPaymentByOrder();
                if (this.creditAgreement.numberOfInstallments !== 0) {
                    this.$store.dispatch('hardwarePaymentByOrder', subscriptionAgreementItems);
                }
                if (this.creditAgreement.totalCredit < this.viewmincreditpayment) {
                    this.$store.dispatch('setCreditCheckValid', true);
                }
                else {
                    this.$store.dispatch('setCreditCheckValid', false);
                }
            }
            else {
                this.resetInstallmentSelectionByOrder(subscriptionAgreementItems, "yes");
                this.$store.dispatch('hardwarePaymentByOrder', subscriptionAgreementItems);
                if (this.creditAgreement.payNow < this.viewmincreditpayment) {
                    this.$store.dispatch('setCreditCheckValid', true);
                }
                else {
                    this.$store.dispatch('setCreditCheckValid', false);
                }
            }

        },
        updateInstallmentSelected: function (id, installments) {
            this.setSelectedCreditInstallments(id, installments);

            const subscriptionAgreementItem = this.getSubscriptionAgreementItem(id);

            this.$store.dispatch('updateHardwarePayment', subscriptionAgreementItem);
        },
        updateInstallmentSelectedByOrder: function (subscriptionAgreementItems, installments) {
            this.setUpfrontAmount(this.creditAgreement.upfrontAmount)
            this.setSelectedCreditInstallmentsByOrder(installments);
            if (this.creditAgreement.numberOfInstallments !== 0) {
                this.$store.dispatch('hardwarePaymentByOrder', subscriptionAgreementItems);
            }
        },
        updatePaymentBy: function (type, id) {
            const subscriptionAgreementItem = this.getSubscriptionAgreementItem(id);

            if (subscriptionAgreementItem.paymentBy !== type) {
                const changePaymentData = {
                    'type': type,
                    'id': id,
                    'loaderTitle': this.viewmodel.getHardwarePaymentLoaderTitle,
                    'loaderMessage': this.viewmodel.getHardwarePaymentLoaderMessage
                };

                this.$store.dispatch('changePaymentBy', changePaymentData);

                if (type === 'cash') { //CASH
                    this.resetInstallmentSelection(id, "yes");
                    this.$store.dispatch('deleteHardwarePayment', subscriptionAgreementItem);
                } else { //CREDIT
                    this.resetInstallmentSelection(id, "no");

                    const downPaymentPlan = this.getDownPaymentPlan(subscriptionAgreementItem);
                    this.creditAccountConfiguration.upfrontAmountPerSubscription[subscriptionAgreementItem.id] = downPaymentPlan.minUpfrontPayment.toString();

                    if (subscriptionAgreementItem.hardwarePaymentId === 0) { // 0 means "Pay now" or "Not created yet"
                        this.$store.dispatch('createHardwarePayment', subscriptionAgreementItem);
                    }
                    else {
                        this.$store.dispatch('updateHardwarePayment', subscriptionAgreementItem);
                    }
                }
            }
        },
        updatePaymentByOrder: function (val, subscriptionAgreementItems) {
            this.paymentBy = val;
            const changePaymentData = {
                'type': this.paymentBy,
                'items': subscriptionAgreementItems,
                'loaderTitle': this.viewmodel.getHardwarePaymentLoaderTitle,
                'loaderMessage': this.viewmodel.getHardwarePaymentLoaderMessage
            };
            this.$store.dispatch('changePaymentByOrder', changePaymentData);
            if (this.order && this.order.paymentBy.toLowerCase() === 'cash') { //CASH
                this.resetInstallmentSelectionByOrder(subscriptionAgreementItems, "yes");
                this.$store.dispatch('hardwarePaymentByOrder', subscriptionAgreementItems);
            }
            else if(this.order && this.order.paymentBy.toLowerCase() === 'credit')
            { //CREDIT
                this.resetInstallmentSelectionByOrder(subscriptionAgreementItems, "no");
                this.creditAccountConfiguration.upfrontAmountPerSubscription = this.viewminupfrontpayment;
                if (this.creditAgreement.numberOfInstallments !== 0) {
                    this.$store.dispatch('hardwarePaymentByOrder', subscriptionAgreementItems);
                }
            }

        },
        // Validate methods
        validateNumber: function (e) {
            var pattern = /^\d+$/;
            if (!pattern.test(e.target.value)) {
                event.target.className = "ts-form-item__field ca-discount-item-input ts-form-item__error";
                e.target.value = "";
            }
            else {
                event.target.className = "ts-form-item__field ca-discount-item-input";
                return true;
            }
        },
        isDiscountAmountValid: function (discountAmount, originalPrice) {
            return discountAmount < originalPrice;
        },
        validateDiscountAmount: function (e, originalPrice) {
            var discountAmount = Number(e.target.value);
            if (!this.isDiscountAmountValid(discountAmount, originalPrice)) { // Not OK
                e.target.className = "ts-form-item__field ca-discount-item-input ts-form-item__error";
            }
            else { // OK
                e.target.className = "ts-form-item__field ca-discount-item-input";
            }
        }
    },
    computed:
        Object.assign(
            mapState({
                existingAgreement: state => state.creditaccount.existingAgreement,
                order: state => state.creditaccount.order,
                downPaymentPlan: state => state.creditaccount.downPaymentPlan,
                customerWantsCreditAgreement: state => state.creditaccount.customerWantsCreditAgreement,
                preAuth: state => state.creditaccount.preAuth,
                joiceCreditCheck: state => state.creditaccount.joiceCreditCheck,
                creditAgreement: state => state.creditaccount.creditAgreement,
                creditEvaluation: state => state.creditaccount.creditEvaluation,
                warnings: state => state.creditaccount.warnings,
                discounts: state => state.creditaccount.discounts,
                totalMonthlyInstallment: state => state.creditaccount.totalMonthlyInstallment,
                isCreditCheckValid: state => state.creditaccount.isCreditCheckValid,
            }),
            mapGetters({
                creditPaymentSelected: 'creditPaymentSelected',
                showCreditAgreementDetails: 'showCreditAgreementDetails',
                orderTotalPrice: 'orderTotalPrice',
            })
        )
}
